
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import T from '../../lang';
import omegaup_Markdown from '../Markdown.vue';
import user_Username from '../user/Username.vue';
import * as time from '../../time';
import { ArenaCourseFeedback, FeedbackStatus } from './Feedback.vue';

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
    'omegaup-user-username': user_Username,
  },
})
export default class FeedbackThread extends Vue {
  @Prop() feedbackThread!: ArenaCourseFeedback;
  @Prop({ default: false }) saved!: boolean;
  @Ref('feedback-thread-form') feedbackThreadForm!: HTMLTextAreaElement;

  FeedbackStatus = FeedbackStatus;
  T = T;
  time = time;
  currentSaved = this.saved;
  currentFeedbackThread = this.feedbackThread;
  isSelectedNewFeedback = false;

  get currentFeedbackThreadTimestamp(): string {
    return time.formatDateTimeLocal(
      this.currentFeedbackThread.timestamp ?? new Date(),
    );
  }

  onHandleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.onDeleteFeedbackThread();
    }
  }

  onSubmitFeedback() {
    this.currentSaved = true;
    this.$emit('submit-feedback-thread', this.currentFeedbackThread);
  }

  onDeleteFeedbackThread() {
    this.currentFeedbackThread.text = '';
    this.isSelectedNewFeedback = false;
  }

  @Watch('isSelectedNewFeedback')
  onIsSelectedNewFeedbackChanged(newValue: boolean): void {
    if (newValue) {
      this.$nextTick(() => this.feedbackThreadForm.focus());
    }
  }
}
